import React, { memo } from "react";
import { Box } from "@pochta/ui";
import styled from "styled-components";
var HamburgerBox = styled(Box).withConfig({
  displayName: "Hamburger__HamburgerBox",
  componentId: "sc-efp39t-0"
})(["position:relative;width:21px;height:17px;&:before,&:after{content:\"\";position:absolute;background:", ";width:100%;height:3px;}&:before{top:0;}&:after{top:7px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.color.importance.primary.base;
});

var Hamburger = function Hamburger(_ref2) {
  var _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick;
  return /*#__PURE__*/React.createElement(HamburgerBox, {
    display: {
      notDesktop: "block",
      desktop: "none"
    },
    onClick: onClick,
    borderBottom: "3px solid importance.primary.base"
  });
};

export default /*#__PURE__*/memo(Hamburger);